"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DeviceCategory extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'deviceCategory';
        this._name = initParams.name;
        this._organisationId = initParams.organisation_id;
        this._colour = initParams.colour;
        this._icon = initParams.icon;
        this._global = initParams.global;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateDeviceCategory(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set organisationId(value) {
        console.error('Do not set objects this way');
    }
    setOrganisationId(value) {
        return this.dataService.updateDeviceCategory(this.id, { organisation_id: value }, this);
    }
    get organisationId() {
        return this._organisationId;
    }
    set colour(value) {
        console.error('Do not set objects this way');
    }
    setColour(value) {
        return this.dataService.updateDeviceCategory(this.id, { colour: value }, this);
    }
    get colour() {
        return this._colour;
    }
    set icon(value) {
        console.error('Do not set objects this way');
    }
    setIcon(value) {
        return this.dataService.updateDeviceCategory(this.id, { icon: value }, this);
    }
    get icon() {
        return this._icon;
    }
    set global(value) {
        console.error('Do not set objects this way');
    }
    setGlobal(value) {
        return this.dataService.updateDeviceCategory(this.id, { global: value }, this);
    }
    get global() {
        return this._global;
    }
    set assetIds(value) {
        console.error('Do not set objects this way');
    }
    setAssetIds(value) {
        return this.dataService.updateDeviceCategory(this.id, { asset_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get assetIds() {
        return this._assetIds;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateDeviceCategory(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateDeviceCategory(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteDeviceCategory(this.id, this);
    }
}
exports.default = DeviceCategory;
//# sourceMappingURL=deviceCategory.js.map